module.exports = __webpack_public_path__ + "static/media/facebook.38e169c5.svg";